import React from "react";
import Slider from "react-slick";
import BundleCard from "./bundleCard";
import { useMediaQuery } from "react-responsive";

const ServiceBundles = ({ content }) => {
  const isMobile = useMediaQuery({ query: "(max-width: 992px)" });

  const PrevArrow = props => {
    const { className, onClick } = props;
    return <button onClick={onClick} className={className} />;
  };

  const NextArrow = props => {
    const { className, onClick } = props;
    return <button onClick={onClick} className={className} />;
  };

  const settings = {
    infinite: true,
    fade: false,
    autoplay: false,
    dots: true,
    arrows: isMobile ? false : true,
    draggable: false,
    slidesToShow: 2,
    rows: 2,
    slidesToScroll: 2,
    cssEase: "cubic-bezier(0.165, 0.840, 0.440, 1.000)",
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    centerMode: false,
    responsive: [
      {
        breakpoint: 1112,
        settings: {
          arrows: false,
          draggable: true
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1.2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1.1,
          slidesToScroll: 1
        }
      }
    ]
  };

  return (
    <div id="serviceBundles">
      <div className="title">{content.title}</div>
      <div className="subtitle">{content.subtitle}</div>
      <Slider {...settings}>
        {content.cards.map((card, i) => (
          <BundleCard key={i} content={card} />
        ))}
      </Slider>
      <div className="caption">{content.caption}</div>
    </div>
  );
};

export default ServiceBundles;
